<template>
    <div v-if="isPopoutRoute">
        <router-view />
    </div>
    <div v-else>
        <div class="ai-chat-app-layout">
            <div class="ai-chat-main-content">
                <div id="modal-target"></div>
                <router-view />
            </div>

            <ai-chat-sidebar v-if="isAuthenticatedAndHasAccess" />
        </div>
    </div>
</template>

<script>
import '../css/tailwind.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue3-perfect-scrollbar/style.css';

import AiChatSidebar from '@components/ai-chat/ai-chat-sidebar.vue';

import ApiClient from '@/api-client';

export default {
    components: {
        AiChatSidebar,
    },

    computed: {
        isAuthenticated() {
            return !!this.$store.state.AuthenticationStore.user?.id;
        },
        isAuthenticatedAndHasAccess() {
            const { user } = this.$store.state.AuthenticationStore;
            return !!user?.id && user.ai_chat_enabled;
        },
        isPopoutRoute() {
            return this.$route.path === '/ai-chat-popout';
        },
    },

    watch: {
        async '$store.state.AuthenticationStore.user.refresh_required'(value) {
            if (value) {
                const response = await this.$swal({
                    icon: 'warning',
                    title: 'Refresh Required',
                    html: 'xLinx has a new update, to take full advantage of the new features a refresh is required.',
                    showCancelButton: false,
                    showLoaderOnConfirm: false,
                    confirmButtonText: 'Refresh',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });

                if (response.value) {
                    localStorage.clear();
                    await ApiClient.patch('/api/user/refreshed');
                    // eslint-disable-next-line no-restricted-globals,no-self-assign
                    window.location.href = window.location.href;
                }
            }
        },
    },
};
</script>

<style>
    .ai-chat-app-layout {
        display: flex;
        height: 100vh;
    }

    .ai-chat-main-content {
        position: relative;
        flex: 1;
        min-width: 0;
        overflow: auto;
    }

    /* Hide Sentry feedback widget when AI chat is open */
    body.ai-chat-open #sentry-feedback,
    body.ai-chat-open [id^="sentry-feedback"],
    body.ai-chat-open .widget__actor {
        display: none !important;
    }
</style>
